import React, { useState, useEffect } from 'react';
import LoadingSpinnerStyled from './LoadingSpinner.styled';

export interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner = ({ className }: LoadingSpinnerProps) => (
  <LoadingSpinnerStyled className={className}>
    <div />
  </LoadingSpinnerStyled>
);

export default LoadingSpinner;
